// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9e876545","455":"dbc2247c","977":"3de11761"}[chunkId] + ".chunk.js";
};